import { mutatorAction } from 'satcheljs';
import type { MailFolder } from 'owa-graph-schema';
import getFolderTable from '../selectors/getFolderTable';
import { addFoldersToFolderTable } from './addFoldersToFolderTableMutator';

// We are using a mutator action because when we retrieve folders from the folder table to update the folder information(DisplayName, childrenFolderIds), we are changing
// stored observable values.
export const updateFolderInformationMutator: (
    rootFolder: MailFolder,
    displayName: string | undefined,
    folders: { [id: string]: MailFolder },
    folderIds: string[],
    defaultChildIdsForRootFolder: string[]
) => void = mutatorAction(
    'updateFolderInformation',
    (
        rootFolder: MailFolder,
        displayName: string | undefined,
        folders: { [id: string]: MailFolder },
        folderIds: string[],
        defaultChildIdsForRootFolder: string[]
    ): void => {
        if (displayName) {
            rootFolder.displayName = displayName; // The passed in folder, if it existed in the table, is a mobx observable.
        }

        if (defaultChildIdsForRootFolder.length > 0) {
            rootFolder.childFolderIds = defaultChildIdsForRootFolder;
            rootFolder.childFolderCount = defaultChildIdsForRootFolder.length;
        }

        for (const folderId of folderIds) {
            const childFolder = folders[folderId];
            // Parent maybe already fetched and did not come as part of this request, so get from store
            const parent =
                folders[childFolder.parentFolderId] ||
                getFolderTable().get(childFolder.parentFolderId); // The folder retreived from getFolderTable is an observable.
            // If the parent exists, but childFolderIds is undefined, then initialize it
            if (parent && !parent?.childFolderIds) {
                parent.childFolderIds = [];
            }
            if (parent?.childFolderIds && parent.childFolderIds.indexOf(folderId) == -1) {
                parent.childFolderIds.push(folderId);
                parent.childFolderCount = parent.childFolderIds.length;
            }
        }

        addFoldersToFolderTable(folders);
    }
);
